<template>
  <div>
    <CustomLoader v-if="isLoading" :width="70" />
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="4" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.booking_number ||
              Filter.container_number ||
              Filter.clientFilter ||
              Filter.slineFilter ||
              Filter.search_txt ||
              Filter.createdByFilter ||
              Filter.branchFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate ||
              Filter.StatusVerbose ||
              Filter.hasDateMismatch ||
              Filter.daysFilter
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.booking_number ||
                  Filter.container_number ||
                  Filter.clientFilter ||
                  Filter.slineFilter ||
                  Filter.search_txt ||
                  Filter.createdByFilter ||
                  Filter.branchFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate ||
                  Filter.StatusVerbose ||
                  Filter.hasDateMismatch ||
                  Filter.daysFilter
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getTimeLineList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getTimeLineList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.pageSize"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
          <b-col cols="6"> </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Booking NO Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Booking NO Filter"
                    id="booking_number" name="booking_number" autocomplete="off" v-model="Filter.booking_number"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="3">
                  <label>Container No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Container No Filter"
                    id="container_number" name="container_number" autocomplete="off" v-model="Filter.container_number"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>
                <b-col md="2">
                  <label>Days</label>
                  <b-form-select v-model="Filter.daysFilter" :options="dayOptions"
                    @change="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" placeholder="Select Days" />
                </b-col>

                <b-col md="3">
                  <label>Shipping Line</label>
                  <model-list-select :list="$store.getters['common/getAllShippingLineList']"
                    v-model="Filter.slineFilter" option-value="shippingId" option-text="shippingLine"
                    placeholder="Select Shipping Line" @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Client</label>
                  <model-list-select :list="$store.getters['common/getAllClientList']" id="clientFilter"
                    v-model="Filter.clientFilter" option-value="clientId" option-text="clientName"
                    placeholder="Select Client Name" @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Branch</label>
                  <model-list-select :list="$store.getters['common/getAllBranchList']" id="branchfilter"
                    v-model="Filter.branchFilter" option-value="pickupId" option-text="pickupLocation" placeholder="All"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Common Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                    id="search_txt" name="search_txt" autocomplete="off" v-model="Filter.search_txt"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Status Verbose</label>
                  <model-list-select :list="StatusVerboseList" v-model="Filter.StatusVerbose"
                    option-value="StatusVerboseVal" option-text="StatusVerboseTxt" placeholder="Select Status Verbose"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>Mismatch Actual/Initial</label>
                  <model-list-select :list="hasDateMismatchList" v-model="Filter.hasDateMismatch"
                    option-value="hasDateMismatchVal" option-text="hasDateMismatchTxt"
                    placeholder="Select Mismatch Actual/Initial"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" />
                </b-col>

                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getTimeLineTrackDash('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName" placeholder="Select Created User" />
                </b-col>

                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive">
              <b-table show-empty stacked="md" responsive :items="getTimeLineList" :fields="TimeLineFields"
                primary-key="id_email_section" :per-page="pagination.pageSize" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="table-background position-relative">
                <template slot="SN" slot-scope="row0">
                  <span style="white-space: nowrap;">
                    {{
                      row0.index + 1 + (pagination.currentPage - 1) * pagination.pageSize
                    }}
                  </span>
                </template>
                <template slot="RaisedFrom" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Branch:</strong> {{ (row0.item.RaisedFrom) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Empty Pickup Loc:</strong> {{ (row0.item.EmptyPickupLoc)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Origin Loc:</strong> {{ (row0.item.OriginLoc)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>POL:</strong> {{ (row0.item.PolLoc) }}</span><br />
                  <span style="white-space: nowrap;"><strong>POD:</strong> {{ (row0.item.PodLoc) }}</span><br />
                  <span style="white-space: nowrap;"><strong>DLV Loc:</strong> {{ (row0.item.DlvLoc) }}</span>
                  <span style="white-space: nowrap;"><strong>Empty Return Loc:</strong> {{ (row0.item.EmptyReturnLoc)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Tsp1 Loc:</strong> {{ (row0.item.Tsp1Loc) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Tsp2 Loc:</strong> {{ (row0.item.Tsp2Loc) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Tsp3 Loc:</strong> {{ (row0.item.Tsp3Loc) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Tsp4 Loc:</strong> {{ (row0.item.Tsp4Loc) }}</span>
                </template>
                <template slot="StatusVerbose" slot-scope="row0">
                  <span><strong>Status Verbose:</strong> {{ (row0.item.StatusVerbose) }}</span><br />
                  <span><strong>Message:</strong> {{ (row0.item.EventMessage) }}</span>
                </template>
                <template slot="BookingNumber" slot-scope="row0">
                  <strong :style="(row0.item.subscription_id) ? 'color: blue;font-weight:bold' : ''" @click="
                    (row0.item.subscription_id) ? goToSubscriptionPage(row0.item) : ''
                    ">Booking No: {{ (row0.item.BookingNumber) }}</strong><br />
                  <span style="white-space: nowrap;"><strong>Job No:</strong> {{ (row0.item.JobNo) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Job Date:</strong> {{ (row0.item.JobDate) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Raised By:</strong> {{ (row0.item.RaisedBy) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Client:</strong> {{ (row0.item.ClientName) }}</span><br />
                  <span style="white-space: nowrap;"><strong>BrfNo:</strong> {{ (row0.item.BrfNo) }}</span><br />
                  <span style="white-space: nowrap;"><strong>IncoTerm:</strong> {{ (row0.item.IncoTerm) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Bl Type:</strong> {{ (row0.item.BlType) }}</span><br />
                  <span style="white-space: nowrap;"><strong>MblNo:</strong> {{ (row0.item.MblNo) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Mbl Release:</strong> {{ (row0.item.MblReleaseDate)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Mbl Date:</strong> {{ (row0.item.MblDate) }}</span><br />
                </template>

                <template slot="container_number" slot-scope="row0">
                  <span style="white-space: nowrap;">Container No: {{ (row0.item.container_number) }}</span><br />
                  <span style="white-space: nowrap;">Vessel Voyage 1: {{ (row0.item.Vessel1 + ' / ' + row0.item.Voyage1)
                  }}</span><br />
                  <span style="white-space: nowrap;">Vessel Voyage 2: {{ (row0.item.Vessel2 + ' / ' + row0.item.Voyage2)
                  }}</span>
                </template>

                <!-- <template slot="VesselVoyage" slot-scope="row0">
                </template> -->
                <!-- <template slot="EmptyPickupLoc" slot-scope="row0"><br />
                  <span><strong>Empty Pickup Loc:</strong> {{ (row0.item.EmptyPickupLoc) }}</span><br />
                  <span><strong>Origin Loc:</strong> {{ (row0.item.OriginLoc) }}</span><br />
                  <span><strong>POL:</strong> {{ (row0.item.PolLoc) }}</span><br />
                  <span><strong>POD:</strong> {{ (row0.item.PodLoc) }}</span><br />
                  <span><strong>DLV Loc:</strong> {{ (row0.item.DlvLoc) }}</span>
                  <span><strong>Empty Return Loc:</strong> {{ (row0.item.EmptyReturnLoc) }}</span><br />
                  <span><strong>Tsp1 Loc:</strong> {{ (row0.item.Tsp1Loc) }}</span><br />
                  <span><strong>Tsp2 Loc:</strong> {{ (row0.item.Tsp2Loc) }}</span><br />
                  <span><strong>Tsp3 Loc:</strong> {{ (row0.item.Tsp3Loc) }}</span><br />
                  <span><strong>Tsp4 Loc:</strong> {{ (row0.item.Tsp4Loc) }}</span>
                </template> -->

                <template slot="SobPlanInitial" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.SobPlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.PolPlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Plan:</strong> {{ (row0.item.SobPlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{ (row0.item.SobPlanDetected)
                  }}</span>
                </template>

                <template slot="Tsp4DepartureLast" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>SI:</strong> {{ (row0.item.SiCB + "/" + row0.item.SiMain)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>VGM:</strong> {{ (row0.item.VgmCb + "/" +
                    row0.item.VgmMain) }}</span><br />
                  <span style="white-space: nowrap;"><strong>TR:</strong> {{ (row0.item.TrCb + "/" + row0.item.TrMain)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Hand:</strong> {{ (row0.item.HandoverCB + "/" +
                    row0.item.HandoverMain) }}</span>
                </template>

                <template slot="Tsp4PlanActual" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{
                    (row0.item.EmptyPickupPlanInitial) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Last:</strong> {{ (row0.item.EmptyPickupPlanLast)
                  }}</span><br />
                  <!-- <span><strong>Departure Plan:</strong> {{ (row0.item.SobPlanActual) }}</span><br /> -->
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.EmptyPickupPlanActual) }}</span>
                </template>

                <template slot="Tsp4PlanLast" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.OriginPlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Last:</strong> {{ (row0.item.OriginPlanLast)
                  }}</span><br />
                  <!-- <span><strong>Departure Plan:</strong> {{ (row0.item.SobPlanActual) }}</span><br /> -->
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{ (row0.item.OriginPlanActual)
                  }}</span>
                </template>

                <template slot="Tsp4PlanInitial" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.PolPlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.PolPlanLast)
                  }}</span><br />
                  <!-- <span><strong>Departure Plan:</strong> {{ (row0.item.SobPlanActual) }}</span><br /> -->
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{ (row0.item.PolPlanActual)
                  }}</span>
                </template>

                <template slot="Tsp4Loc" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.PodPlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.PodPlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Plan:</strong> {{ (row0.item.PodDepartureInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.PodDepartureActual) }}</span>
                </template>

                <template slot="Tsp3DepartureLast" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.Tsp1PlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.Tsp1PlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Plan:</strong> {{
                    (row0.item.Tsp1DepartureInitial) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.Tsp1DepartureActual) }}</span>
                </template>


                <template slot="Tsp3PlanActual" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.Tsp2PlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.Tsp2PlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Plan:</strong> {{
                    (row0.item.Tsp2DepartureInitial) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.Tsp2DepartureActual) }}</span>
                </template>

                <template slot="Tsp3PlanInitial" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.Tsp3PlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.Tsp3PlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Plan:</strong> {{
                    (row0.item.Tsp3DepartureInitial) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.Tsp3DepartureActual) }}</span>
                </template>

                <template slot="Tsp1DepartureLast" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{ (row0.item.Tsp4PlanInitial)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.Tsp4PlanActual)
                  }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Plan:</strong> {{
                    (row0.item.Tsp4DepartureInitial) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.Tsp4DepartureActual) }}</span>
                </template>

                <template slot="Tsp1DepartureInitial" slot-scope="row0">
                  <span style="white-space: nowrap;"><strong>Arrival Plan:</strong> {{
                    (row0.item.EmptyReturnPlanInitial) }}</span><br />
                  <span style="white-space: nowrap;"><strong>Arrival Actual:</strong> {{ (row0.item.EmptyReturnPlanLast)
                  }}</span><br />
                  <!-- <span><strong>Departure Plan:</strong> {{ (row0.item.EmptyReturnPlanActual) }}</span><br /> -->
                  <span style="white-space: nowrap;"><strong>Departure Actual:</strong> {{
                    (row0.item.EmptyReturnPlanActual) }}</span>
                </template>

                <template slot="Tsp1PlanActual" slot-scope="row0">
                  <!-- <span>Arrival Plan: {{ (row0.item.SobPlanInitial) }}</span><br />
                  <span>Arrival Actual: {{ (row0.item.PolPlanActual) }}</span><br />
                  <span>Departure Plan: {{ (row0.item.SobPlanActual) }}</span><br />
                  <span>Departure Actual: {{ (row0.item.SobPlanDetected) }}</span> -->
                </template>

              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.pageSize"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import TrasportService from "../../services/TrasportService";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant";

import ShipmentTimeline from "./ShipmentTimeline.vue"

export default {
  name: "milestoneTrack",
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);

    const storePromises = [
      this.$store.dispatch(
        "common/setAllUserList",
        JSON.stringify({
          itemCode: "GET_USERLIST_Data",
        })
      ),
      this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      ),

      this.$store.dispatch(
        "common/setAllClientList",
        JSON.stringify({ itemCode: "ClientList" })
      ),
      this.$store.dispatch(
        "common/setAllShippingLineList",
        JSON.stringify({ itemCode: "ShippingLineList" })
      ),

    ];
    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    Promise.all(storePromises)
      .then(() => delay(1000))
      .then(() => {
        console.log("All store actions completed.");
      })
      .catch((error) => {
        console.error("Error dispatching store actions:", error);
      });

    this.$store.dispatch("setCurrentRoute", this.$router.history.current.fullPath);
    this.getCurrentLastDate();

    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getTimeLineList: [],
      totalData: 0,
      StatusVerboseList: [{
        StatusVerboseVal: "1",
        StatusVerboseTxt: "Running",
      }, {
        StatusVerboseVal: "2",
        StatusVerboseTxt: "Completed",
      }, {
        StatusVerboseVal: "3",
        StatusVerboseTxt: "All",
      }],

      hasDateMismatchList: [{
        hasDateMismatchVal: "1",
        hasDateMismatchTxt: "Mismatch",
      }, {
        hasDateMismatchVal: "2",
        hasDateMismatchTxt: "All",
      }],

      TimeLineFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
          tdClass: 'no-wrap'
        },
        {
          key: "RaisedFrom",
          mainkey: "RaisedFrom",
          label: "BRANCH NAME",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "StatusVerbose",
          mainkey: "StatusVerbose",
          label: "Status Verbose",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "NextPort",
          mainkey: "NextPort",
          label: "NEXT PORT",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "BookingNumber",
          mainkey: "BookingNumber",
          label: "Booking No.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "SlineName",
          mainkey: "SlineName",
          label: "SLINE",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "container_number",
          mainkey: "container_number",
          label: "CONTAINER NO.",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        // {
        //   key: "VesselVoyage",
        //   mainkey: "VesselVoyage",
        //   label: "Vessel Name",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        //   tdClass: 'no-wrap'
        // },
        // {
        //   key: "EmptyPickupLoc",
        //   mainkey: "EmptyPickupLoc",
        //   label: "Location",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        //   tdClass: 'no-wrap'
        // },
        {
          key: "SobPlanInitial",
          mainkey: "SobPlanInitial",
          label: "SOB",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp4DepartureLast",
          mainkey: "Tsp4DepartureLast",
          label: "SI",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        // {
        //   key: "Tsp4DepartureInitial",
        //   mainkey: "Tsp4DepartureInitial",
        //   label: "VGM",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        //   tdClass: 'no-wrap'
        // },
        // {
        //   key: "Tsp4PlanDetected",
        //   mainkey: "Tsp4PlanDetected",
        //   label: "TR",
        //   sortable: true,
        //   sortDirection: "ASC",
        //   table: "C.",
        //   tdClass: 'no-wrap'
        // },
        {
          key: "Tsp4PlanActual",
          mainkey: "Tsp4PlanActual",
          label: "Empty Pickup",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp4PlanLast",
          mainkey: "Tsp4PlanLast",
          label: "Origin",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp4PlanInitial",
          mainkey: "Tsp4PlanInitial",
          label: "POL",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp4Loc",
          mainkey: "Tsp4Loc",
          label: "POD",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp3DepartureLast",
          mainkey: "Tsp3DepartureLast",
          label: "TSP1",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp3PlanActual",
          mainkey: "Tsp3PlanActual",
          label: "TSP2",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp3PlanInitial",
          mainkey: "Tsp3PlanInitial",
          label: "TSP3",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp1DepartureLast",
          mainkey: "Tsp1DepartureLast",
          label: "TSP4",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp1DepartureInitial",
          mainkey: "Tsp1DepartureInitial",
          label: "EMPTY RETURN@POD",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
        {
          key: "Tsp1PlanActual",
          mainkey: "Tsp1PlanActual",
          label: "Pridel Prediction",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
          tdClass: 'no-wrap'
        },
      ],

      pagination: {
        currentPage: 1,
        pageSize: 50,
        totalPages: 0,
        totalCounts: 0,
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      Filter: {
        booking_number: "",
        container_number: "",
        clientFilter: "",
        slineFilter: "",
        search_txt: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
        StatusVerbose: "1",
        hasDateMismatch: "1",
        daysFilter: "2",
      },
      //Added By Priyanshu Singh Multi Select Start

      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      generateExcel: "0",
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
    ShipmentTimeline,
  },
  computed: {},
  watch: {},
  methods: {
    goToSubscriptionPage(item) {
      if (item.subscription_id) {
        this.$router.push({
          path: "/tracking/ocean-insights/subscription/" + item.subscription_id,
        });
      }
    },
    clearFilter() {
      this.Filter = {
        booking_number: "",
        container_number: "",
        clientFilter: "",
        slineFilter: "",
        search_txt: "",
        createdByFilter: "",
        branchFilter: "",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
        StatusVerbose: "1",
        hasDateMismatch: "1",
        daysFilter: "2",
      };
      this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    getTimeLineTrackDash(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.totalData = 0;
      this.getTimeLineList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getTimeLineList",
        type: type,
        currentPage: this.pagination.currentPage,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        filter: this.Filter,
        generateExcel: this.generateExcel,
        isAll: this.generateExcel,
        search_txt: this.Filter.search_txt,
      };

      const config = this.generateExcel == "1" ? { responseType: "blob" } : {};

      TrasportService.getMilestoneSubscriptionTrack(payload, config)
        .then((response) => {
          const { data, status, statusText } = response;

          if (status == 200 && data) {
            if (this.generateExcel == "1") {

              const blob = new Blob([data], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              });
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "TrackReport.xlsx");
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);

              this.ExcelBtnName = "Export As Excel";
              this.generateExcel = "0";
              this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
            } else {
              if (data.data.length > 0) {
                this.pagination = data.pagination;
                 this.totalData = data.pagination.totalCounts[0].totalCount;
                this.getTimeLineList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getTimeLineList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getTimeLineTrackDash("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.generateExcel = "1";
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getTimeLineTrackDash("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.pageSize - this.pagination.pageSize;
      }
      this.getTimeLineTrackDash("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      console.log("event=>", event);
      this.pagination.currentPage = event;
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.pageSize - this.pagination.pageSize;
      }
      this.getTimeLineTrackDash("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>

<style scoped>
.table-background thead {
  background-color: #a9e4ce;
  border-color: lightgrey;
  border-bottom-style: none;
  border-style: solid;
  border-width: 2px;
  height: 40px;
  position: sticky;
  top: 0;
  font-size: 11px;
}

.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}

.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}

.table-wrapper-scroll-y {
  display: block;
}

.md-body-1,
.pendencyBody {
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.01em;
  line-height: 20px;
}

.table-background>tbody {
  font-size: 11px;
}

.table-background>thead {
  color: black;
}

.status-alerts {
  font-size: 18px;
  /* display: flex; */
  flex-direction: column;
  /* margin-bottom: 20px; */
}

.alert {
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); */
  color: #fff;
}

.alert-danger-text {
  /* background-color: #d9534f; Bootstrap danger color */
  color: #d9534f;
  /* Bootstrap danger color */
}

.alert-info-text {
  color: #2a6fde;
  /* background-color: #2a6fde; Bootstrap danger color */
}

.alert-warning {
  background-color: #f0ad4e;
  /* Bootstrap warning color */
}

.alert strong {
  margin-right: 5px;
}

@keyframes blink2 {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.blink2 {
  animation: blink2 1s infinite;
  /* Adjust the duration as needed */
}

.blink {
  animation: blinker 1s linear infinite;
  font-weight: 800;
  color: red;
}

.blink-circle {
  width: 10px;
  height: 10px;
  background-color: red;
  border-radius: 50%;
  animation: blinker 6s linear infinite;
  /* 6 seconds for three color changes */
}

@keyframes blinker {

  0%,
  100% {
    background-color: red;
  }

  33% {
    background-color: green;
  }

  66% {
    background-color: blue;
  }
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.no-wrap {
  font-size: 8px;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// milestoneTrackTable.vue?0b8026dc